import { render } from "./WageCalculationsList.vue?vue&type=template&id=6d7843da"
import script from "./WageCalculationsList.vue?vue&type=script&lang=js"
export * from "./WageCalculationsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__